import { render, staticRenderFns } from "./uInput.vue?vue&type=template&id=4e4736be&scoped=true&"
import script from "./uInput.vue?vue&type=script&lang=js&"
export * from "./uInput.vue?vue&type=script&lang=js&"
import style0 from "./uInput.vue?vue&type=style&index=0&id=4e4736be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4736be",
  null
  
)

export default component.exports